/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Scheduled_Sync_DailyInputs */



/**
* | output |
* | --- |
* | "Daily" |
*
* @param {Spaces_Scheduled_Sync_DailyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_scheduled_sync_daily = /** @type {((inputs?: Spaces_Scheduled_Sync_DailyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Scheduled_Sync_DailyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Täglich")
	return /** @type {LocalizedString} */ ("Daily")
});